module.exports = __webpack_public_path__ + "img/icon-nav4_blue.1d86a544.svg";